import { browser } from '@atlaskit/editor-common/browser';
export var getDragBehaviour = function getDragBehaviour(_ref) {
  var altKey = _ref.altKey,
    ctrlKey = _ref.ctrlKey;
  var isCloneModifierKeyPressed = browser.mac ? altKey : ctrlKey;
  return isCloneModifierKeyPressed ? 'clone' : 'move';
};